<template>
<div class="chapter">
<div class="inner_page">
<p><a id="p01"></a></p>
<div class="ct"><b>PART ONE</b></div>
<div class="cst"><b>The Evolving State of ESPM</b></div>
<div class="tx1">No one would argue that software development has undergone a major change in the past decade. On what seems to be a continuous basis you are bombarded with the latest and greatest models, tools, templates, and processes. You may be confused and wonder which of these, if any, make any sense. Should you use this one or that one or maybe the same one for all software development projects?</div>
<div class="tx1">In this part I will lay the groundwork for what proposes to be the introduction of a new discipline—one that fully integrates software development life cycles and project management life cycles. This is the first attempt at defining such a discipline. Much remains to be done. But at least I can lay claim to trying to bring some order out of the seeming chaos faced by software developers and their project management partners.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wyso_9780470446539_oeb_p01_r1.vue?52c93100